import {HttpErrorResponse} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ResultDto} from '../dto/ResultDto';

export abstract class ErrorHandler {

  protected handleError(error: HttpErrorResponse | unknown): Observable<ResultDto<undefined>> {
    console.error(error);
    // @ts-expect-error some error types are not known
    const message = error.error?.data?.message || 'Unknown error';
    console.error(message);
    return of(ResultDto.error(message));
  }

}
